/**
 * Created by katarinababic on 5.11.24.
 */

import { makeAutoObservable } from 'mobx';
import { ExploreEntryQueryRequest } from './ExploreEntryQueryRequest';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { v1ParamsToV3Params } from './exploreV3Params';

export type ExploreFilterTagJson = {
  id: string;
  count: number;
};

export type ExploreFilterTag = ExploreFilterTagJson;

export function createExploreFilterTag(json?: Partial<ExploreFilterTagJson>): ExploreFilterTag {
  return makeAutoObservable({
    id: json?.id ?? '',
    count: json?.count ?? 0,
  });
}

export const ExploreFilterTagApi = {
  find(request: ExploreEntryQueryRequest): Promise<ExploreFilterTag[]> {
    return HttpBackend.get(`/coach/explore/v3/entries/tags`, v1ParamsToV3Params(request)).then((res) =>
      (res ?? []).map((r: ExploreFilterTagJson) => createExploreFilterTag(r)),
    );
  },
};
